<template>
  <!-- 热文榜 -->
  <div id="hotList">
    <div class="title_bg">
      <p>{{ title }}</p>
    </div>
    <div class="list_wrap">
      <!-- <hotlistitem
        v-for="(list, index) in lists"
        :nfh="list"
        @popSupport="popSupport"
        :key="list.id"
        :index="index"
        :isLatest="isLatest"
        :hitList="hitList"
        @getUuid="getHitList"
      ></hotlistitem> -->
      <hotlistitem
        v-for="(list, index) in lists"
        :nfh="list"
        :key="list.id"
        :index="index"
      ></hotlistitem>
      <div v-if="!lists || lists.length == 0" class="no_data">暂无数据~</div>
    </div>
  </div>
</template>
<script>
import { initShare } from "@/js/shareWx.js";
import { shareUrl, shareTitle, shareDesc, shareIcon } from "@/js/shareInfo.js";
import hotlistitem from "@/components/hotlistitem.vue";
import support from "@/components/support.vue";
import { nanfangIfUrl, nfplusUrl } from "@/js/url";
// import { getUuid } from "@/js/wx";
// import weui from "weui.js";
import getParamsFromUrl from "@/js/getParamsFromUrl";
export default {
  data() {
    return {
      lists: [],
      periods: [],
      nowPeriod: -1,
      latestPeriod: 0,
      isLatest: true,
      nowLabel: "第1期榜单（02.01-02.07）",
      showSupport: false,
      supportObj: {},
      hitList: [],
      tipsMsg: "",
      hasGetUuid: false,
      title: "",
      linkID: "",
      articleId: "",
    };
  },
  created() {
    this.getPeriods();
    this.getHotData();
  },
  methods: {
    getPeriods() {
      $.ajax({
        url: `${nanfangIfUrl}/nfh/popular/periods`,
        type: "GET",
        dataType: "json",
        data: {},
        success: (res) => {
          let data, nowPeriod;
          if (res.code === 200) {
            data = res.data.list;
            this.periods = data.map((item) => {
              return {
                label: `第${item.periods}期榜单（${item.startTime}-${item.endTime}）`,
                value: item.periods,
              };
            });
            nowPeriod = data[0] ? data[0].periods : 1;
            this.latestPeriod = nowPeriod; //记录最新一期
            this.nowPeriod = nowPeriod;
            this.nowLabel = `第${nowPeriod}期榜单（${data[0].startTime}-${data[0].endTime}）`;
            //this.getNowPeriod(nowPeriod);
          }
        },
      });
    },
    goRule() {
      //跳转打榜规则页面
      this.$router.push({ path: "/rule", query: { catName: this.catName } });
    },
    getNowPeriod(nowPeriod) {
      $.ajax({
        url: `${nanfangIfUrl}/nfh/popular/popularByPeriods`,
        type: "GET",
        dataType: "json",
        data: {
          periods: nowPeriod,
        },
        success: this.getNowPeriodSuc,
      });
    },
    getNowPeriodSuc(res) {
      if (res.code === 200) {
        this.lists = res.data.list;
        const article = res.data.article;
        this.title = article.title;
        this.initShareInfo(article.secondaryShare, article.picSmall, article.channelShareIcon);
      }
      if (res.code === 404) {
        window.location.href = "https://static.nfnews.com/apptpl/new404.html";
      }
    },

    async getAppStyle() {
      let that = this;
      $.ajax({
        url: `${nanfangIfUrl}/app/getAppStyle`,
        type: "GET",
        dataType: "json",
        success: function (result) {
          console.log("==222==", result);
          if (result.code === 200) {
            that.getDetailsStyle(result.data);
          }
        },
      });
    },
    async getDetailsStyle(appStyleInfo) {
      console.log("------", appStyleInfo);
      // 获取dom节点
      const domEl = document.getElementsByTagName("html")[0];
      if (appStyleInfo && +appStyleInfo.themeType === 1) {
        // 全局黑白
        if (this.hasClass(domEl, "notgrayscale")) {
          this.removeClass(domEl, "notgrayscale");
        }
        this.addClass(domEl, "grayscale");
      } else {
        // 全局彩色
        if (this.hasClass(domEl, "grayscale")) {
          this.removeClass(domEl, "grayscale");
        }
        this.addClass(domEl, "notgrayscale");
      }
    },
    hasClass(curEle, className) {
      var reg = new RegExp("(^| +)" + className + "( +|$)");
      return reg.test(curEle.className);
    },
    addClass(curEle, className) {
      var arr = className.replace(/(^ +| +$)/g, "").split(/ +/g); // 先去首尾空格，为了防止className为多个类名 "box1 box2"
      for (var i = 0, len = className.length; i < len; i++) {
        var curName = arr[i];
        if (!this.hasClass(curEle, className)) {
          if (i === 0) {
            curEle.className += "" + curName;
          } else {
            curEle.className += " " + curName;
          }
        }
      }
    },
    removeClass(curEle, className) {
      var arr = className.replace(/(^ +| +$)/g, "").split(/ +/g);
      for (var i = 0, len = className.length; i < len; i++) {
        var curName = arr[i];
        if (this.hasClass(curEle, curName)) {
          var reg = new RegExp("(^| +)" + curName + "( +|$)", "g");
          curEle.className = curEle.className.replace(reg, " ");
        }
      }
    },

    //获取人气榜TOP30
    getHotData() {
      // let url = 'https://devstatic.nfnews.com/apptpl/hotArticleShare/#/cityHotNewsRanking?articleId=283534&catId=1'
      let params = getParamsFromUrl();
      $.ajax({
        url: `${nfplusUrl}/nfh/listCityHotNewsFifty`,
        type: "GET",
        dataType: "json",
        data: {
          catId: params.catId,
          articleId: params.articleId,
        },
        success: this.getNowPeriodSuc,
      });
    },
    initShareInfo(secondaryShare, picSmall, channelShareIcon) {
      let iconUrl = shareIcon;
      if (secondaryShare === 0 && picSmall) {
        iconUrl = picSmall;
      } else if (channelShareIcon) {
        iconUrl = channelShareIcon
      }
      const shareData = {
        //请求失败回调
        getShareFail: () => {
          console.log("微信请求调用失败");
        },
        //分享标题
        title: shareTitle,
        //分享描述
        desc: shareDesc,
        //分享图片地址
        iconUrl: iconUrl,
        //需要分享的路径，不传默认本页面
      };
      initShare(shareData);
    },
  },
  watch: {},
  components: {
    hotlistitem: hotlistitem,
    support,
  },
  mounted() {
    this.getAppStyle();
    //阻止页面刷新
    try {
      activity.setReloadWhileOnPause(false);
    } catch (e) {}
    this.initShareInfo();
  },
};
</script>
<style lang="less">
@import url("../less/mixin.less");
@import url("../less/my_weui.css");
@import url("../less/font_size.less");
#hotList {
  // height: 100%;
  // position: relative;
  margin-bottom: 0.6rem;
  .rule_btn {
    box-sizing: border-box;
    position: absolute;
    right: 0;
    top: 0.7rem;
    width: 1.6rem;
    height: 0.72rem;
    line-height: 0.65rem;
    font-size: 0.26rem;
    color: #bb3b14;
    text-align: right;
    padding-right: 0.2rem;
    .bg-image("../img/Rectangle2");
    cursor: pointer;
  }
  .title_bg {
    position: absolute;
    left: 1.8rem;
    right: 1.5rem;
    top: 0.35rem;
    height: 1.55rem;
    display: flex;
    justify-content: center;
    .bg-image("../img/hot_tit_bg");
    p {
      padding-top: 0.9rem;
      line-height: 1;
      font-size: 0.32rem;
      font-weight: bold;
    }
  }
  .list_wrap {
    box-sizing: border-box;
    position: relative;
    margin: 1.8rem auto 0.6rem;
    min-height: 9.5rem;
    background-color: #fff;
    border-radius: 4px;
    padding-top: 0.1rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
  }
  .index_wrap {
    box-sizing: border-box;
    position: relative;
    //top: 2.04rem;
    // width: 6.9rem;
    margin: 2.04rem auto 0.6rem;
    min-height: 9.5rem;
    background-color: #fff;
    border-radius: 4px;
    padding-top: 0.9rem;
    .period_select {
      position: absolute;
      top: -0.14rem;
      left: 1rem;
      right: 1rem;
      height: 0.6rem;
      .bg-image("../img/title_list_bg");
      display: flex;
      justify-content: center;
      align-items: center;
      /*font-size: 0.3rem;*/
      font-weight: bold;
      color: #d03304;
      cursor: pointer;
      &:before {
        content: "";
        display: block;
        position: absolute;
        width: 0.28rem;
        height: 0.26rem;
        .bg-image("../img/star_icon");
        top: 50%;
        left: -0.28rem;
      }
      &:after {
        content: "";
        display: block;
        position: absolute;
        width: 0.28rem;
        height: 0.26rem;
        .bg-image("../img/star_icon");
        top: 50%;
        right: -0.28rem;
      }
      .select_down_arrow {
        display: inline-block;
        width: 0.2rem;
        height: 0.1rem;
        .bg-image("../img/down_arrow_icon");
      }
    }
    .no_data {
      width: 100%;
      height: 20px;
      line-height: 20px;
      font-size: 0.26rem;
      text-align: center;
      color: #ccc;
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: -10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/cityHotNewsRanking.vue